

































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import pressurePO from "@/store/entities/devices/pressure/pressurepo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Common } from "@/lib/Common/Guid";
import Util from "@/lib/util";
@Component({
  components: { TreeSelect },
})
export default class EditPressure extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  entity: pressurePO = new pressurePO();
  loading: boolean = false;
  created() {
    this.areaTree();
    this.getItemDetail();
    this.getSupplier();
    this.getModelList();
    this.getCollectorList();
  }
  async getpressuremodel(val: any) {
    if (val != undefined && val > 0) {
      await this.$store
        .dispatch({ type: "pressuremodel/get", id: val })
        .then((ele) => {
          if (ele != null) {
            this.entity = ele;
            this.entity.modelId = val;
          }
        })
        .catch((err) => {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: err,
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
        });
    }
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 13) {
          this.$data.transferType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 3) {
          this.$data.ispType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 5) {
          this.$data.potocolType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 17) {
          this.$data.deviceType.push({ label: ele.name, value: ele.id });
        }
      });
      let mt = detaillist.filter((p) => {
        return p.itemId == 7;
      });
      mt.forEach((ele) => {
        this.$data.meterType.push({ label: ele.name, value: ele.id });
      });
    }
    var devicew = JSON.parse(localStorage.getItem("devicewaringvalue"));
    if (devicew.length > 0) {
      devicew.forEach((ele) => {
        this.$data.deviceWaring.push({ label: ele.name, value: ele.id });
      });
    }
  }
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "pressure/update",
            data: this.entity,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    this.entity = Util.extend(
      true,
      {},
      this.$store.state.pressure.pressureItems
    );
  }
  modelRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceNo: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    meterType: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    modelId: [
      {
        required: true,
        type: "number",
        message: this.L("Model") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    imei: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    collectorId: [{}],
    transferType: [
      {
        required: true,
        type: "integer",
        message:
          this.L("Transfer") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    protocol: [
      {
        required: true,
        type: "integer",
        message: this.L("Protocol") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "integer",
        message: this.L("ISP") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceType: [
      {
        required: true,
        type: "integer",
        message: this.L("DeviceType") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceWaringValueId: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
  };
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getSupplier() {
    this.$data.suppliers = [];
    await this.$store
      .dispatch("supplier/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.suppliers.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getModelList() {
    this.$data.modelList = [];
    await this.$store
      .dispatch("pressuremodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.modelList.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getCollectorList() {
    (this.$data.collectorList = []),
      await this.$store
        .dispatch("collector/getalllist")
        .then((val) => {
          if (val.length > 0) {
            val.forEach((ele) => {
              this.$data.collectorList.push({ label: ele.no, value: ele.id });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
  }
  data() {
    return {
      arealist: [],
      transferType: [],
      ispType: [],
      levelType: [],
      supplier: [],
      potocolType: [],
      suppliers: [],
      modelList: [],
      collectorList: [],
      meterType: [],
      deviceType: [],
      deviceWaring: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
